<template>
  <div class="login" v-loading.fullscreen.lock.fullscreen.lock="loading">
    <div class="login_header">
      <img src="@/assets/image/login/logo.png" />
      <div class="login_header_txt">
        <img src="@/assets/image/login/dianxian.png" />
        <span>考核报名系统</span>
      </div>
    </div>
    <div class="form_content">
      <div class="login_form">
        <div class="editionType" v-if="editionType">{{testTxt}}</div>
        <Form
          ref="Loginform"
          :model="formValidate"
          :rules="ruleValidate"
          label-position="left"
          @keydown.enter.native="login('Loginform')"
        >
          <FormItem prop="name">
            <Input prefix="ios-contact" v-model="formValidate.name" placeholder="请输入手机号" />
          </FormItem>
          <FormItem prop="password">
            <Input
              prefix="ios-lock"
              v-model="formValidate.password"
              type="password"
              password
              placeholder="请输入密码"
            />
          </FormItem>
          <div class="login_footer">
            <router-link :to="{path:'/forgetCipher'}" class="password_txt">忘记密码</router-link>
            <div class="register_txt">
              <span>没有账号？</span>
              <router-link :to="{path:'/register'}">立即注册</router-link>
            </div>
          </div>
          <div class="form_submit">
            <Button type="primary" long @click="login('Loginform')">登录</Button>
          </div>
        </Form>
        <div class="login_hint">推荐使用"谷歌浏览器"或者"360浏览器极速模式"</div>
      </div>
    </div>
  </div>
</template>
<style lang="less">
.login {
  height: 100%;
  background: url("./../../../assets/image/login/login.png") no-repeat top
    center;
  background-size: cover;
  position: relative;
  .login_header {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 18%;
    .login_header_txt {
      text-align: center;
      padding-top: 10px;
      position: relative;
      span {
        position: absolute;
        left: 50%;
        top: 7px;
        transform: translateX(-50%);
        font-size: 18px;
        font-weight: 500;
      }
    }
  }
  .form_content {
    width: 360px;
    height: 334px;
    position: absolute;
    left: 50%;
    top: 32%;
    transform: translateX(-50%);
    background: url("./../../../assets/image/login/duobianxin.png") no-repeat
      top center;
    background-size: cover;
  }
  .login_form {
    height: 100%;
    padding: 76px 40px 58px;
    box-sizing: border-box;
    position: relative;
  }
  .editionType {
    position: absolute;
    left: 50%;
    top: 30px;
    height: 30px;
    line-height: 30px;
    color: #fff;
    background: #ff0000;
    transform: translateX(-50%);
    padding: 0 20px;
    font-size: 18px;
  }

  .form_submit {
    text-align: center;
    .ivu-btn {
      background: #00b49b;
    }
  }

  .login_footer {
    height: 40px;
    line-height: 40px;
    margin-bottom: 5px;

    .register_txt {
      float: right;
      a {
        color: #00b49b;
      }
    }

    .password_txt {
      float: left;
      color: #00b49b;
    }
  }
  .login_hint {
    position: absolute;
    left: 0;
    bottom: 20px;
    width: 100%;
    text-align: center;
    font-size: 13px;
    height: 30px;
    line-height: 30px;
  }
}
</style>
<script>
import util from "@/libs/util";
import { AccountLogin } from "@/api/account/index";
export default {
  data() {
    return {
      loading: false,
      formValidate: {
        name: "",
        password: ""
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入用户密码",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    //登录
    login(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.loading = true;
          let params = {
            user_name: this.formValidate.name,
            password: this.$md5(this.formValidate.password).toUpperCase()
          };
          AccountLogin(params)
            .then(async res => {
              //储存登录成功后的token和pass
              util.cookies.set("token", res.access_token);
              //储存用信息
              util.storage.setUserInfo(res.user_info);
              // 重定向对象不存在则返回顶层路径
              this.$router.replace(this.$route.query.redirect || "/");
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>